module.exports = __webpack_public_path__ + "img/mounting.36b0ba25.jpg";